import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { cn } from '../../../utils';
import { BinIcon, ImageIcon, LoaderIcon } from '../../../icons';
import { imageUploadStyling, imagePreviewStyling, placeholderStyling, iconStyling, removeBtnStyling, removeIconStyling, } from './styling';
export function UncontrolledImageUpload({ value, onChange, error, className, size, disabled, isLoading }) {
    const inputRef = useRef(null);
    const [imageUrl, setImageUrl] = useState(value ? URL.createObjectURL(value) : undefined);
    const handleChange = (e) => {
        const file = e.target.files?.[0] ?? undefined;
        if (file) {
            setImageUrl(URL.createObjectURL(file));
        }
        onChange(file);
    };
    const handleClick = () => inputRef.current?.click();
    const handleRemove = (e) => {
        e.stopPropagation();
        if (imageUrl) {
            URL.revokeObjectURL(imageUrl);
            setImageUrl(undefined);
        }
        onChange(undefined);
    };
    return (_jsxs("div", { children: [_jsxs("button", { type: "button", onClick: handleClick, className: cn(imageUploadStyling({
                    size,
                    _error: !!error,
                }), className), children: [imageUrl
                        ? (_jsx("img", { src: imageUrl, alt: "Profile", className: imagePreviewStyling({ size }) }))
                        : (_jsx("div", { className: placeholderStyling({ size }), children: isLoading
                                ? _jsx(LoaderIcon, { className: iconStyling({ size }) })
                                : _jsx(ImageIcon, { className: iconStyling({ size }) }) })), imageUrl && (_jsx("div", { role: "button", "aria-label": "Clear Image", onClick: handleRemove, className: removeBtnStyling({ size }), children: _jsx(BinIcon, { className: removeIconStyling({ size }) }) }))] }), _jsx("input", { ref: inputRef, type: "file", accept: "image/*", onChange: handleChange, className: "hidden", disabled: disabled })] }));
}
